





























import { Component, Vue, Prop } from 'vue-property-decorator'
import VueDatePicker from 'vue2-datepicker'
import 'vue2-datepicker/index.css'
import 'vue2-datepicker/locale/pt-br'
import moment from 'moment'
import PureVue from 'vue'
import { DeepPartial } from '../utils/types'
import { Component as VueComponent, ComponentOptions, ComputedOptions } from 'vue/types/options'
import { ExtendedVue, CombinedVueInstance } from 'vue/types/vue'

  export type DatePickerType = 'date' | 'datetime' | 'year' | 'month' | 'time' | 'week'
  export type DatePickerMethods = { closePopup: (this: VueComponent, ...args: string[]) => void }
  export type DatePickerComponent = CombinedVueInstance<any, any, DatePickerMethods, any, any>

  @Component({
    components: {
      VueDatePicker,
    },
  })
  export default class DatePicker extends Vue {

    @Prop()
    private value!: Date | Array<string>;

    @Prop({ default: 'Selecione a data' })
    private placeholder!: string;

    @Prop({ default: 'date' })
    private type!: DatePickerType;

    @Prop({ default: 'DD/MM/YYYY HH:mm' })
    private format!: string;

    @Prop()
    private classes!: string;

    @Prop({ default: 'YYYY-MM-DD HH:mm' })
    private valueType!: string;

    @Prop()
    private disabled!: boolean;

    @Prop()
    private range!: boolean;

    @Prop()
    private disabledDate: (date: Date) => boolean

    @Prop()
    showTimePanel: boolean

    private datePicker: DatePickerComponent

    private lang: any = {
      formatLocale: {
        weekdaysMin: ['Do', 'Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sáb'],
      } as DeepPartial<VueDatePicker.Lang>,
    };

    mounted() {
      this.datePicker = this.$refs.datePicker as DatePickerComponent
    }

    private updateValue(value: Date) {
      let response: Date | Array<string> = value
      if (this.type === 'month') {
        response = [
          moment(value, this.valueType).startOf('month').format(this.valueType),
          moment(value, this.valueType).endOf('month').format(this.valueType),
        ];
      }

      this.$emit('input', response);
    }

    get defaultValue() {
      if (this.type === 'month') {
        return this.value[0];
      }
      return this.value;
    }

    close() {
      this.datePicker.closePopup()
    }

    onClose() {
      return this.$emit('close')
    }

  }
